import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombDual = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const patterUrl = getPatternImages(state);

    var lightGuards =
      typeof state.context.custom.lightGuards === 'number' ? 'Yes' : '';

    const railColour = state.context.custom.railColour
      ? state.context.custom.railColour
      : 'White';
    const railColourHex = getHoneycombRailHexColour(railColour);

    if (lightGuards !== 'Yes') {
      return (
        <svg
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 554.2 420"
          {...props}
        >
          <defs>
            <pattern
              id="hcDual"
              patternUnits="userSpaceOnUse"
              width="100"
              height="100"
            >
              <image href={patterUrl} x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>
          <path fill="url(#hcDual)" d="M5 88.3h544.2v251.5H5z" />
          <g fill={`${railColourHex}`}>
            <path d="M554.2 10V0H0v10h32v78.3H2.6v5h549.1v-5h-25.9V10h28.4zM33.8 10H278v78.3H33.8V10zM524 88.3H279.8V10H524v78.3zM2.6 334.8h549.1v5H2.6z" />
          </g>
        </svg>
      );
    } else {
      return (
        <svg
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 554.2 409"
          {...props}
        >
          <defs>
            <pattern
              id="hcDual"
              patternUnits="userSpaceOnUse"
              width="100"
              height="100"
            >
              <image href={patterUrl} x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>
          <path fill={`${railColourHex}`} d="M5 88.3h544.2v251.5H5z" />
          <path
            d="M0 0v409h5v-69.3h544.2V409h5V0H0zm279.8 88.3V10H524v78.3H279.8zm-246 0V10H278v78.3H33.8zM5 10h26.9v78.3H5V10zm544.2 324.8H5V93.3h544.2v241.5zm0-246.5h-23.4V10h23.4v78.3z"
            fill="#939391"
          />
        </svg>
      );
    }
  },
);
